<div bsModal
     #assignAssessment="bs-modal"
     id="assignAssessment"
     class="modal fade"
     (onShown)="onShown()"
     role="dialog"
     aria-labelledby="purchaseAssessment"
     aria-hidden="true"
     [config]="{backdrop: 'static'}">

    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Assign Assessments</h2>
            </div>

            <div class="modal-body">
                <!--AG GRID Assessments-->
                <div class="displayNone">
                    <h5>Assessments</h5>

                    <div class="manageAssessmentTabs">
                        <ul class="tab-nav" id="assessmentTypes">
                            <li (click)="selectedTab(1)" class="active"><a data-toggle="tab" href="#manageTab1">ELI - Self Assessment</a></li>
                            <li (click)="selectedTab(2)"><a data-toggle="tab" href="#manageTab2">ELI 360</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="manageTab1" class="tab-pane fade in active">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #assessmentsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="assessmentsGridOptions"
                                                 [rowData]="assessmentsELIData"
                                                 [columnDefs]="assessmentsHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onAssessessmentRowClicked($event)"
                                                 (gridReady)="assignOnGridReady(1,$event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [rowSelection]="'single'"
                                                 (selectionChanged)="onAssessmentsSelectionChanged(1, $event)">
                                </ag-grid-angular>
                            </div>
                        </div>

                        <div id="manageTab2" class="tab-pane fade">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #assessmentsGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="false"
                                                 [gridOptions]="assessmentsGridOptions"
                                                 [rowData]="assessments360Data"
                                                 [columnDefs]="assessmentsHeaders"
                                                 [enableSorting]="false"
                                                 [enableColResize]="false"
                                                 (rowClicked)="onAssessessmentRowClicked($event)"
                                                 (gridReady)="assignOnGridReady(2,$event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [rowSelection]="'single'"
                                                 (selectionChanged)="onAssessmentsSelectionChanged(2, $event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer text-right">
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />
                <input (click)="openAssignModal()" type="button" class="btn btn-primary waves-effect" value="Next" />
            </div>
        </div>
    </div>
</div>

<app-assign-assesments-new-modal #assignAssessmentNew></app-assign-assesments-new-modal>